import { ViewChild, ElementRef, Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, RouterModule, Routes } from '@angular/router';
import { HomeService } from '../../services/home.service';

declare var jQuery:any;
@Component({
  selector: 'app-ongoing',
  templateUrl: './ongoing.component.html',
  styleUrls: ['./ongoing.component.scss']
})
export class OngoingComponent implements OnInit {
  exerciseId:any=null;
  exerciseDetailsObj:any={image:'',audio:''};
  audioStatus:string='play';
  audioWidth:string='0%';
  progressInterval:any;
  timerInterval:any;
  audioDuration:any='0:00';
  audioCurrentTime:any='0:00';
  cancelExercise:boolean=false;
  exerciseStartSeconds:Number=5;
  showProgressBar:boolean=false;
  showFeedbackContent:boolean=true;
  showFeedback:boolean=false;
  disableSendFeedback:boolean=false;
  feedbackBtnText:string='';
  feedback_id:Number=null;
  smiley1:string='assets/images/1.png';
  smiley2:string='assets/images/2.png';
  smiley3:string='assets/images/3.png';
  smiley4:string='assets/images/4.png';
  @ViewChild('dismissModal') dismissModal:ElementRef;
  @ViewChild('audioOption') audioPlayerRefObj: ElementRef;
  constructor(private homeService: HomeService, private router:Router) { }

  ngOnInit() {
    let url = this.router.url;
    let exerciseUrl = url.split('/exercise/')[1];
    this.exerciseId = exerciseUrl.split('/ongoing')[0];
    if(this.exerciseId) {
      this.getExerciseDetails(this.exerciseId);
    }
  }

  showTimer() {
    // setTimeout(() => {
      this.timerInterval = setInterval(() => {
        this.exerciseStartSeconds = +this.exerciseStartSeconds-1;
        if(this.exerciseStartSeconds == 0) {
          this.showProgressBar = true;
          clearInterval(this.timerInterval);
         // this.onAudioPlay();
        }
      }, 1000);
    // }, 1000);
  }

  getExerciseDetails(id) {
    this.showTimer();
    this.progressInterval = setInterval(() => {
      // if(parseInt(this.audioDuration) >0 && this.audioCurrentTime == '0:00' && this.showProgressBar) {
      //   this.onAudioPlay();
      //   clearInterval(this.progressInterval);
      // }
      this.getAudioDetails(); 
    }, 1000);
    this.homeService.eachExerciseDetails(id).subscribe(res=>{
      this.exerciseDetailsObj = res;
      this.updateExercise(this.exerciseId);
    });
  }

  updateExercise(id) {
    let redo = true;
    if(id == 'current') {
      id = this.exerciseDetailsObj.id;
      redo = false;
    }
    let data = {"completed":true,"redo":redo}
    this.homeService.updateExerciseDetails(data,id).subscribe(res=>{
    });
  }

  goToExercise() {
    this.cancelExercise = true;
    if(this.progressInterval) {
      clearInterval(this.progressInterval);
    }
    if(this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    this.dismissModal.nativeElement.click();
    if(this.exerciseId == 'current') {
      this.exerciseId = this.exerciseDetailsObj.id;
    }
    this.router.navigate(['/exercise/'+this.exerciseId]);
  }

  onAudioPlay(){
    if(this.audioDuration == 0) {
      alert('Please wait audio is taking some time to load...');
      return true;
    }
    this.audioPlayerRefObj.nativeElement.play();
    this.audioStatus = 'pause';
    this.progressInterval = setInterval(() => {
      this.getAudioDetails(); 
    }, 1000);
  }

  onAudioPause(){
    if(this.audioCurrentTime == '0:00') {
      alert('Please wait audio is taking some time to load...');
      this.audioPlayerRefObj.nativeElement.play();
      return true;
    }
    clearInterval(this.progressInterval);
    this.audioPlayerRefObj.nativeElement.pause();
    this.audioStatus = 'play';
  }

  exerciseModal() {
    if(this.audioStatus == 'pause') {
      this.audioPlayerRefObj.nativeElement.pause();
    }
  }

  getAudioDetails() {
    var audioElement = <any>document.getElementById("exerciseAudio");
    if(audioElement == null) {
      return true;
    }
    let duration = audioElement.duration | 0;
    let currentTime = audioElement.currentTime | 0;
    let width = 100 / duration * currentTime;
    if(width == 100) {
      //Show the feedback modal when audio is completed.
      jQuery('#feedbackModal').modal('show');
    }

    // if(currentTime == 0 && this.showProgressBar) {
    //   this.audioPlayerRefObj.nativeElement.play();
    //   this.audioStatus = 'pause';
    // }

    if(width <=100){
      let totalMinutes = this.formatTime(duration)
      this.audioDuration = totalMinutes;
      let time = this.formatCurrentTime(currentTime)
      this.audioCurrentTime = time;
      this.audioWidth = width+'%';
    }
  }

  formatTime(seconds) {
    let minutes = Math.floor(seconds / 60)
    if (minutes >= 10) {
      minutes = minutes
    }else if(minutes == 0) {
      minutes = 0
    }
    let second:any;
    second = Math.floor(seconds % 60)
    if (second >= 10) {
      second = second
    }else {
      second = '0'+second
    }
    let minute = minutes + ':' + second
     return minute;
  }

  formatCurrentTime(seconds) {
    let minutes:any;
    minutes = Math.floor(seconds / 60)
    let second:any;
    second = Math.floor(seconds % 60)
    if (second < 10) {
      second = '0'+second
    }
    let minute = minutes + ':' + second
     return minute;
  }

  cancelAction() {
    if(this.audioStatus == 'pause' && !this.cancelExercise) {
      this.audioPlayerRefObj.nativeElement.play();
    }
  }

  feedbackNotNow(value?) {
    this.showFeedbackContent =false;
    if(value != 'no') {
      let id = this.exerciseDetailsObj.id;
      let type = 'exercises';
      let obj = JSON.stringify({feedback_id:this.feedback_id,comment:this.feedbackBtnText});
      this.homeService.saveFeedback(type,id,obj).subscribe(res => {
      })
    }
  }

  navigateAction (path) {
    let navigatePath = path;
    if(path == 'paths') {
      navigatePath = `/paths/${this.exerciseDetailsObj.path_id}`
    }
    jQuery('#feedbackModal').modal('hide');
    //Clear the interval because audio play is completed
    if(this.progressInterval) {
      clearInterval(this.progressInterval);
    }
    //Navigate to respective page.
    this.router.navigate([navigatePath]);
  }

  onChangeFeedbackInput(value) {
    this.disableSendFeedback = true;
  }

  rating(number) {
    this.imagesUrl();
    switch (number) {
      case 1:
          this.smiley1='assets/images/active_1.png';
          break;
      case 2:
          this.smiley2='assets/images/active_2.png';
          break;
      case 3:
          this.smiley3='assets/images/active_3.png';
          break;
      case 4:
          this.smiley4='assets/images/active_4.png';
          break;
    }
    this.feedback_id = number;
    this.showFeedback = true;
  }

  imagesUrl() {
    this.smiley1='assets/images/1.png';
    this.smiley2='assets/images/2.png';
    this.smiley3='assets/images/3.png';
    this.smiley4='assets/images/4.png';
  }

}



// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/ongoing/ongoing.component.ts